import { impactAsync, ImpactFeedbackStyle, selectionAsync } from "@-/com.npmjs.expo-haptics";
import { Platform } from "@-/com.npmjs.react-native";

/** Haptics are a nicety: an unavailable engine (web, tests, an old device) is never an error. */
export function playOnboardingFeedback(kind: "confirm" | "select") {
  if (Platform.OS === "web") {
    return;
  }
  (kind === "confirm" ? impactAsync(ImpactFeedbackStyle.Light) : selectionAsync()).catch(() => {});
}
